import React from 'react';
import {Card, SkeletonDisplayText, SkeletonBodyText} from '@shopify/polaris';

import styles from './RequestQuote.scss';

export function SkeletonRequestQuote() {
  return (
    <div className={styles.RequestQuote}>
      <Card>
        <Card.Section>
          <SkeletonDisplayText size="medium" />
          <div className={styles.Container}>
            <SkeletonBodyText lines={4} />
          </div>
        </Card.Section>
      </Card>
    </div>
  );
}
